import { generateCorrelationId, RequestData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface ConfirmRequest extends RequestData {
    type: '@stemcstudio/modal-dialog-service:confirm';
    title: string;
    message: string;
    /**
     * The cancel button text. Defaults to 'Cancel'.
     */
    cancelButtonText?: string;
    /**
     * The action button text. Defaults to 'OK'.
     */
    actionButtonText?: string;

}

/**
 * @hidden
 */
export function isConfirmRequest(message: MessageEvent): message is MessageEvent<ConfirmRequest> {
    const duck = message as MessageEvent<ConfirmRequest>;
    if (duck.data.type && duck.data.type === '@stemcstudio/modal-dialog-service:confirm') {
        return true;
    } else {
        return false;
    }
}

/**
 * @hidden
 */
export function createConfirmRequest(title: string, message: string, actionButtonText: string, cancelButtonText: string): ConfirmRequest {
    const id = generateCorrelationId();
    return {
        type: '@stemcstudio/modal-dialog-service:confirm',
        id,
        title: title,
        message: message,
        actionButtonText: actionButtonText,
        cancelButtonText: cancelButtonText
    };
}
